
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export interface EmptyGroupsStateProps {
  onAddGroup: () => void;
}

const EmptyGroupsState: React.FC<EmptyGroupsStateProps> = ({ onAddGroup }) => {
  return (
    <Card className="glass-card col-span-full">
      <CardContent className="flex flex-col items-center justify-center py-8">
        <p className="text-center text-gray-500 dark:text-gray-400 mb-4">
          No groups have been created yet
        </p>
        <Button 
          onClick={onAddGroup}
          className="bg-teal-500 hover:bg-teal-600 text-white"
        >
          Create Your First Group
        </Button>
      </CardContent>
    </Card>
  );
};

export default EmptyGroupsState;
